import { ApiName } from "@ipru-common/services/ApiEndpoints";
import useService from "./useService";
import { LifeCoverOption, LMS_CONSTANTS, SUCCESS } from "@ipru-common/constants/SiteConstants";
import { EbiPaymentOptionName, EXISTCUST, OPTION_VALUES } from "@ipru-common/constants/InputValues";
import { getProductDetail, reFormatDate, splitFullName } from "@ipru-common/utils/CommonFunctions";
import { useGlobalContext } from "@ipru-common/context/GlobalContext";

export default function useWebhookApi() {
  const { callService } = useService();
  const {
    global: {
      calculatorFormData,
      quoteFormData,
      appFormData,
      isTdPersonaJourney,
      UID,
      activeLanguage,
      existingCustDetails,
      currentPageSection,
    },
  } = useGlobalContext();
  const { appNO, formWizard: { personalDetails = {}, nomineeDetails = {}, occupationDetails = {} } = {} } =
    appFormData ?? {};
  const {
    emailid,
    yr_income,
    gender,
    user_dob,
    calc_occupation,
    calc_education,
    mobileno,
    pageName,
    tobacco,
    country_code,
    is_nri_in_india,
    nri_india_arriving_date,
    nri,
  } = calculatorFormData ?? {};

  const productDetail = getProductDetail();

  const { firstName, lastName } = splitFullName(personalDetails?.full_name ?? "");

  const callWebhook = async (data) => {
    const payload = {
      PAD_ADD_EMAIL: emailid ?? "",
      pfp_ann_income: yr_income ?? "",
      Gender: gender ?? "",
      DOB: user_dob ?? "",
      apf_app_no: data?.appNo ?? appNO ?? "",
      apf_agnt_id: UID ?? "",
      apf_prod_id: productDetail?.code ?? "",
      prq_policy_name: productDetail?.name ?? "",
      prq_trnsctionendtime: new Date().toLocaleTimeString(),
      agnt_code: UID ?? "",
      fsc_channel: "BOL",
      pad_add_city: personalDetails?.city ?? "",
      pad_add_state: personalDetails?.state ?? "",
      pad_add_country: personalDetails?.per_country ?? "",
      ped_prsn_edu: calc_education ?? personalDetails?.highest_education ?? "",
      pod_prsn_occptn: calc_occupation ?? "",
      ebi_premium_term: quoteFormData?.term ?? "",
      ebi_totalpremium: quoteFormData?.breakupDetail?.total ?? 0,
      ebi_policy_term: quoteFormData?.term ?? "",
      death_benefit_payout_option: EbiPaymentOptionName[quoteFormData?.paymentOption] ?? "",
      benefit_option: "",
      critical_illness_benefit: "",
      ebi_adbr_sum_assured: "",
      ebi_prmium_payng_frq: LMS_CONSTANTS[quoteFormData?.tenure] ?? quoteFormData?.tenure ?? "",
      mobile: mobileno ?? "",
      insert_date: reFormatDate(new Date().toLocaleDateString()) ?? "",
      custregdate: reFormatDate(new Date().toLocaleDateString()) ?? "",
      apf_page_name: pageName ?? "",
      gender: gender ?? "",
      pfp_annl_income: yr_income ?? "",
      ape_calculated: "",
      dob: user_dob ?? "",
      amount_breakup: "",
      apf_bre_decision: "",
      apf_created_time: new Date().toLocaleTimeString(),
      coverageoption: "",
      ebi_adbr_term: "",
      ebi_annualpremium: quoteFormData?.breakupDetail?.total ?? 0,
      ebi_death_benefit: "",
      ebi_lifecover: quoteFormData?.SA ?? 0,
      ebi_modal_premium: quoteFormData?.breakupDetail?.total ?? 0,
      ebi_sumassured: quoteFormData?.SA ?? 0,
      ebi_tobacco: tobacco === OPTION_VALUES.TOBACCO_CONSUMER_YES ? "1" : "0",
      first_visit_timestamp: new Date().toLocaleTimeString(),
      guaranteed_income: "",
      guaranteedbenefit: "",
      income_frequency: LMS_CONSTANTS[quoteFormData?.tenure] ?? quoteFormData?.tenure ?? "",
      income_period: "",
      lms_income_frequency: LMS_CONSTANTS[quoteFormData?.tenure] ?? quoteFormData?.tenure ?? "",
      lms_income_period: quoteFormData?.term ?? "",
      monthly_income: yr_income ? yr_income / 12 : 0,
      prop_annual_income: yr_income ?? "",
      prop_dob: user_dob ?? "",
      prop_education: calc_education ?? personalDetails?.highest_education ?? "",
      prop_gender: gender ?? "",
      prq_payment_status: "",
      prq_premiumfrequency: LMS_CONSTANTS[quoteFormData?.tenure] ?? quoteFormData?.tenure ?? "",
      status: "",
      term_critical_illness: "",
      total_guaranteedreturn: "",
      plantype: LifeCoverOption[quoteFormData?.planType] ?? "",
      prq_final_premium_amount: quoteFormData?.breakupDetail?.total ?? 0,
      pref_datetimenew: "",
      rider1name: "",
      rider1sumassured: "",
      rider1term: "",
      rider1premium: "",
      rider2name: "",
      rider2sumassured: "",
      rider2term: "",
      rider2premium: "",
      prq_si_opted: "",
      prq_mode_of_payment: "",
      policy_status: "",
      proposal_acceptance_date: new Date().toLocaleDateString(),
      first_issuance_date: new Date().toLocaleDateString(),
      transaction_date: new Date().toLocaleDateString(),
      userfullname: personalDetails?.full_name ?? "",
      "agnt _code": "",
      fsc_code: "",
      fsc_branch: "",
      fsc_source: "",
      casescaseid: "",
      pri_maritl_sts: personalDetails?.marital_status ?? "",
      country_code: country_code ?? "",
      w2ccustref: mobileno ?? "",
      lead_type: "",
      flag: "",
      entityid: "",
      payment_entityid: "",
      combocode: "",
      annuity_option: "",
      callcenterruleid: "",
      campaignruleid: "",
      caseid: "",
      client_id: "",
      corpus_amount: "",
      date_of_retirement: "",
      dependent_flag: "",
      derivedlanguage: activeLanguage ?? "",
      dncflag: "",
      e_mail: emailid ?? "",
      pad_email: emailid ?? "",
      ebi_atp_targetfund: "",
      ebi_atp_transferdate: "",
      ebi_atp_transferfund: "",
      ebi_cashbenefitmode: "",
      ebi_cashstartyear: "",
      ebi_childage: "",
      ebi_childage_maturity: "",
      ebi_portfoliostrategy: "",
      ebi_spouse_dob: "",
      ebi_staff_flag: "",
      first_visit_source: "",
      gamooga_id: "",
      gavisitorid: "",
      google_keyword: "",
      guaranteed_earlyincome: "",
      incomebenefit: "",
      is_la_eq_pf_flag: "",
      joint_annuitant_name: "",
      la_prev_policy_sa: "",
      lead_id: "",
      nri: "",
      lms_column_6: "",
      lms_guaranteedcashbenefit: "",
      lms_guaranteedcashbenefit2: "",
      lms_nps_flag: "",
      lms_pagename: pageName ?? "",
      lms_pageurl: "",
      lumpsum: quoteFormData?.breakupDetail?.total ?? 0,
      match_type: "",
      nam_guardian_rltnshp: nomineeDetails?.nominee_relationship ?? "",
      nam_nomine_rltnshp: nomineeDetails?.nominee_relationship ?? "",
      nominee_dob: nomineeDetails?.nominee_dob ?? "",
      nps_flag: "",
      pad_add_landmark: personalDetails?.landmark ?? "",
      pad_add_pin: personalDetails?.pincode ?? "",
      pad_trai_dnd: "",
      pfp_objctve_of_policy: "",
      pri_prsn_nationlty: "",
      prop_add_city: personalDetails?.city ?? "",
      prop_add_country: personalDetails?.per_country ?? "",
      prop_add_pin: personalDetails?.pincode ?? "",
      prop_add_state: personalDetails?.state ?? "",
      prop_la_relation: "",
      prop_marital_status: personalDetails?.marital_status ?? "",
      prop_nation_cntry: personalDetails?.per_country ?? "",
      prop_nationality: "",
      prop_occupation: calc_occupation ?? "",
      prop_occupation_desc: "",
      prop_org_desc: occupationDetails?.nameOfOrgDesc ?? "",
      prop_org_name: occupationDetails?.organisation_name ?? "",
      prop_org_name_desc: occupationDetails?.nameOfOrgDesc ?? "",
      prop_org_type: occupationDetails?.organisation_type ?? "",
      prop_res_status: "",
      scrapreason: "",
      source_id: "",
      spouse_dob: "",
      spouse_gender: "",
      subcategory: "",
      subflag: "",
      lms_nri: "",
      pip_sum_assre: "",
      youth_express: existingCustDetails?.CLIENT_NAME ? EXISTCUST.existCustYes : EXISTCUST.existCustNo,
      lms_child_dob: "",
      lms_column_10: "",
      pod_prsn_orgnstn_nm: occupationDetails?.organisation_name ?? "",
      quote_page_values: "",
      uploadsource: "",
      optformoneyback: "",
      moneybackpercent: "",
      moneybackyear: "",
      lowcoverbooster: "",
      lms_column_4: "",
      payment_caseid: "",
      pri_frst_nm: firstName?.split(" ")?.[0] ?? "",
      pri_mdle_nm: firstName?.split(" ")?.[1] ?? "",
      pri_lst_nm: lastName ?? "",
      nri_in_india: nri === OPTION_VALUES.NRI_YES ? (is_nri_in_india ?? "") : "",
      nri_arvl_in_india: nri === OPTION_VALUES.NRI_YES ? (nri_india_arriving_date ?? "") : "",
      pran_number: personalDetails?.pan_number ?? "",
      prq_bank_name: "",
      prq_payment_gateway: "",
      qrops: "",
      pad_add_line1: personalDetails?.address_line1 ?? "",
      prop_alt_email: emailid ?? "",
      freshrepeatleads: "",
      target_year_month: "",
      w2ccustref_mod: "",
      first_touch_uid: "",
      utm_keyword: "",
      utm_adcontent: "",
      utm_source: "",
      utm_campaign: "",
      utm_w2ccustref: "",
      utm_adcontent_raw: "",
      combocode_contract_d: "",
      nri_indicator: "",
      wapi: "",
      keyman_flag: "",
      fsc_bank: "",
      ape_calculated_1: "",
      combocode_transactional: "",
      record_source: "",
      cs_assignuser: "",
      finalentityid: "",
      tdEvent: currentPageSection ?? "",
    };

    const MAX_RETRIES = 4;

    const callWebhookWithRetry = (retryCount = 0) => {
      callService({
        params: {
          apiName: ApiName.WEBHOOK,
          method: "POST",
          data: payload,
        },
        loader: false,
      })
        .then((response) => {
          const { status } = response;

          if (status === SUCCESS) {
            console.log("WEBHOOK API CALLED SUCCESSFULLY!");
          } else if (status === 401 && retryCount < MAX_RETRIES) {
            callWebhookWithRetry(retryCount + 1);
          }
        })
        .catch((error) => {
          if (error?.status === 401 && retryCount < MAX_RETRIES) {
            callWebhookWithRetry(retryCount + 1);
          } else {
            console.error("WEBHOOK API CALL FAILED!");
          }
        });
    };

    if (isTdPersonaJourney) callWebhookWithRetry();
  };

  return { callWebhook };
}
